import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import merge from 'deepmerge-json';
import { DEFAULT_LANGUAGE_CODE } from 'ngx-mat-esign360/lib/shared/constants/language.constants';

const I18N_HASH_TEMP: string = JSON.stringify(new Date().getTime().toString());

@Injectable({
  providedIn: 'root',
})
export class CustomTranslationLoaderService extends TranslateHttpLoader {
  constructor(private httpClient: HttpClient) {
    // ?v param for cache busting
    super(httpClient, './assets/i18n/', `.json?v=${I18N_HASH_TEMP}`);
  }

  getOverrideJson(lang: string): Observable<object> {
    return this.httpClient.get(`assets/i18n/${lang}-override.json`).pipe(
      catchError((error: unknown) => {
        console.warn(`Override json for "${lang}" language could not be loaded`);

        if (error instanceof HttpErrorResponse) {
          if (error.status === 404) {
            console.warn(`Override json for "${lang}" language not found`);
          } else {
            console.error(error);
          }
        } else {
          console.error(error);
        }
        return of({});
      })
    );
  }

  getTranslation(lang: string) {
    return forkJoin([
      super.getTranslation(lang),
      // ?v param for cache busting
      this.httpClient.get(`assets/i18n/${lang}-shared.json?v=${I18N_HASH_TEMP}`),
      this.getOverrideJson(lang),
    ]).pipe(
      map((data) => merge({ ...data[0], ...data[1] }, data[2])),
      catchError(() => {
        return this.getTranslation(DEFAULT_LANGUAGE_CODE);
      })
    );
  }
}
